import { io } from "socket.io-client";

// En production le backend sert le build React : le socket vit sur la même
// origine que la page. Une URL en dur (« localhost ») ne veut rien dire depuis
// le navigateur d'un joueur — d'où la valeur vide, qui laisse socket.io viser
// l'origine courante. En développement, le front tourne sur le port 3000 et
// doit joindre le backend explicitement.
const SOCKET_URL =
  process.env.REACT_APP_API_URL ||
  (process.env.NODE_ENV === "production" ? "" : "http://localhost:4000");

export const socket = SOCKET_URL ? io(SOCKET_URL) : io();
